<app-user-form (onSubmitCallback)="onSubmit($event[0])"></app-user-form>
